module.exports = __webpack_public_path__ + "media/images/twitter-5c62063df0bace789ca4b74e7cc456af.png";